import React from "react";
import { useFormContext } from "react-hook-form";
import { Form } from "@sscs/ui";
import { useCurrentOrganization } from "Hooks";
import { useGetGroupListQuery } from "Services";
import styles from "./selectGroup.module.scss";

type SelectGroupProps = {
  name: string;
};

// used to populate the group drop down the in the second column
const SelectGroup = ({ name }: SelectGroupProps): React.JSX.Element => {
  const currentOrganization = useCurrentOrganization();

  const {
    formState: { errors },
  } = useFormContext();

  const {
    data = {
      groups: [],
      match_count: 0,
    },
  } = useGetGroupListQuery(
    {
      organizationId: currentOrganization?.id || "",
      limit: 1000,
    },
    { skip: !currentOrganization },
  );

  return (
    <div className={styles["select-group"]}>
      <Form.Autocomplete
        name={name}
        isClearable={false}
        getOptionLabel={(option) =>
          data.groups.find((group) => group.group_id === option)?.name ?? ""
        }
        options={data.groups.map((group) => group.group_id)}
        errors={errors}
        helperText="Map to Spectra Assure group"
      />
    </div>
  );
};

export default SelectGroup;
